import { Injectable, inject } from '@angular/core';
import type { RouterStateSnapshot } from '@angular/router';
import { TitleStrategy } from '@angular/router';
import { SITE_NAME } from '@freelancer/config';
import { TitleService } from './title.service';

@Injectable()
export class DefaultSitenameTitleStrategy extends TitleStrategy {
  private readonly titleService = inject(TitleService);
  private readonly siteName = inject(SITE_NAME);

  override updateTitle(routerState: RouterStateSnapshot): void {
    const title = this.buildTitle(routerState);
    this.titleService.setTitle(title || this.siteName, !!title);
  }
}
